import React from 'react';
import cx from 'classnames';
import { Button } from './Button/index.js';
import styles from './index.module.scss.js';

const Links = ({
  links,
  v2,
  paddingTop,
  isCircle = false
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, {
      [styles["padding-top"]]: paddingTop,
      [styles["is-circle"]]: isCircle
    }, "modal-element-row")
  },
  links.map(({ icon, customIcon, onClick }, index) => /* @__PURE__ */ React.createElement(
    Button,
    {
      icon,
      customIcon,
      key: index,
      onClick,
      className: isCircle ? styles["button-circle"] : null,
      v2
    }
  ))
);
Links.displayName = "Auth.Links";

export { Links };
//# sourceMappingURL=index.js.map
